import { defineStore } from 'pinia'
import { displayErrorMessage, fetchApi } from '~/queries'
import type { ItemType } from '~/types'

export const useFavouritesStore = defineStore('favourites', {
  actions: {
    async addToFavourites(id: string, type: ItemType) {
      const authToken = useCookie('authToken')
      const { $toast, $i18n, $analyticsManager } = useNuxtApp()
      const auth = useAuthStore()
      const modals = useModalsStore()
      const { t } = $i18n

      if (!authToken.value || !auth.user?.id) {
        modals.openLoginModal()

        $toast.error(t('feedback.favourites.login'))

        return
      }

      try {
        await fetchApi(`/clients/${auth.user.id}/favourites`, {
          method: 'POST',
          body: { id, type },
        })

        $analyticsManager.trackAddToWishlist(id, type)

        $toast.success(t('feedback.favourites.added'))
      } catch (error) {
        displayErrorMessage(error)
      }
    },
    async removeFromFavourites(favouriteId: string, type: ItemType) {
      const authToken = useCookie('authToken')
      const { $toast, $i18n } = useNuxtApp()
      const auth = useAuthStore()
      const { t } = $i18n

      if (!authToken.value || !auth.user?.id) {
        return
      }

      try {
        await fetchApi(`/clients/${auth.user.id}/favourites/${favouriteId}`, {
          method: 'DELETE',
          body: { type },
        })

        $toast.success(t('feedback.favourites.removed'))
      } catch (error) {
        displayErrorMessage(error)
      }
    },
    async toggleFavourite({
      id,
      type,
      favouriteId,
    }: {
      id?: string
      type: ItemType
      favouriteId?: string | null
    }) {
      if (favouriteId) {
        await this.removeFromFavourites(favouriteId, type)

        return
      }

      if (id) {
        await this.addToFavourites(id, type)
      }
    },
  },
})
